import { checkDirectSalesAvailabilityAction } from 'store/dealManagement/actions/checkDirectSalesAvailability';
import { cancelFunctions } from 'utils/cancelFunctions';
import { CheckAvailabilityArgs } from './campaignPostSaveRefresh.types';

export const checkAvailability = async ({
  dispatch,
  settings,
  foundSavedLineId,
  overrideLineId,
  shouldAwaitAvailability,
}: CheckAvailabilityArgs): Promise<void> => {
  const shouldCheckAvailability =
    settings.checkAvailability === 'always' ||
    (settings.checkAvailability === 'whenSavedLineFound' && !!foundSavedLineId);

  if (!shouldCheckAvailability) return;

  const availabilityLineId = settings.checkAvailability === 'whenSavedLineFound' ? foundSavedLineId : overrideLineId;
  const availabilityCheck = dispatch(
    checkDirectSalesAvailabilityAction({ overrideLineId: availabilityLineId, cancelFunctions }),
  );

  if (shouldAwaitAvailability) await availabilityCheck;
};
